import { lazy, Suspense } from 'react';
//
import EditorToolbar, { formats } from './EditorToolbar';
import EditorToolbarStyle from './EditorToolbarStyle';

// Duas trocas neste arquivo (13/08/2026):
//
// 1. react-quill -> react-quill-new. O react-quill 2.0.0 usa `findDOMNode`, que
//    o React 19 REMOVEU - o editor quebraria em tempo de execucao. O
//    react-quill-new e o fork mantido, com a mesma API (props value/onChange/
//    modules/formats), entao o resto do arquivo nao mudou.
//
// 2. next/dynamic -> React.lazy + Suspense. O `ssr: false` do next/dynamic nao
//    tem mais funcao: sem SSR no Vite, nao existe render no servidor para
//    desligar. Trocar remove uma dependencia do Next de um componente usado em
//    3 telas, o que ajuda a chegar na remocao do Next.
//
// 3. MUI styled -> Tailwind + inline style. RootStyle vira uma div com classes
//    Tailwind que muda de border-color se houver erro.
//
// O carregamento continua tardio de proposito: o Quill e pesado e so aparece nas
// telas de cadastro que tem campo de texto rico.

const ReactQuill = lazy(() => import('react-quill-new'));

function CarregandoEditor() {
  return (
    <div className="absolute inset-0 bg-surface flex items-center justify-center">
      Loading...
    </div>
  );
}

export default function Editor({
  id = 'minimal-quill',
  error = null,
  value,
  onChange,
  simple = false,
  helperText = null,
  sx = null || undefined || {} || '',
  ...other
}) {
  const modules = {
    toolbar: {
      container: `#${id}`,
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true,
    },
    syntax: true,
    clipboard: {
      matchVisual: false,
    },
  };

  // A prop sx e aceita para compatibilidade com chamadores legados, mas ao
  // contrario da versao MUI, nao pode ser null (evita erros). Classe de erro
  // muda border-color se houver erro.

  return (
    <div>
      <div
        className={`
          overflow-hidden relative rounded-lg
          border transition-colors
          ${error ? 'border-danger' : 'border-line'}
        `}
        style={sx && typeof sx === 'object' ? sx : {}}
      >
        <EditorToolbarStyle id={id}>
          <EditorToolbar id={id} isSimple={simple} />
        </EditorToolbarStyle>

        <Suspense fallback={<CarregandoEditor />}>
          <ReactQuill
            value={value}
            onChange={onChange}
            modules={modules}
            formats={formats}
            placeholder="Coloque sua mensagem aqui"
            {...other}
          />
        </Suspense>
      </div>

      {helperText && <div className="mt-2 text-sm text-danger">{helperText}</div>}
    </div>
  );
}
